import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'
import returnsServices from '@/returns/services/services'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'

const useMarkAsPaid = ({ orderId, setToastInfo }) => {
  const [showMarkAsPaidModal, setShowMarkAsPaidModal] = useState(false)

  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)

  const { fetchData: markAsPaid, loading: markingAsPaid } = useFetch(returnsServices.markAsPaid, {
    doInitialRequest: false,
  })

  const handleMarkAsPaid = async (notes, paidReason) => {
    const payload = {
      notes,
      reason: paidReason,
    }

    try {
      const response = await markAsPaid({ orderId, payload })

      setShowMarkAsPaidModal(false)
      setPendingWebsocketAction(pendingWebsocketActionTypes.markAsPaid, response)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const openMarkAsPaidModal = () => {
    setShowMarkAsPaidModal(true)
  }

  const closeMarkAsPaidModal = () => {
    setShowMarkAsPaidModal(false)
  }

  return {
    showMarkAsPaidModal,
    setShowMarkAsPaidModal,
    handleMarkAsPaid,
    markingAsPaid,
    openMarkAsPaidModal,
    closeMarkAsPaidModal,
  }
}

export default useMarkAsPaid
